import T from './../types';

export default function clearOffers() {
  return {
    type: T.OFFERS_FETCH_RESET,
  };
}
